import React from 'react';

import { IconProps } from '../DefaultIcon';

export function RgpdIcon({ className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="uuid-bcdcd639-a7b0-4838-95e7-00474d15d354"
      viewBox="0 0 88.6 88.8"
      className={className}
    >
      <defs>
        <style>
          {'.st0{fill:#00416b}.st1{fill:#00c4b3}.st2{isolation:isolate}'}
        </style>
      </defs>
      <path
        d="M78.4 88.8V4c0-2.2-1.8-4-4-4H4C1.8 0 0 1.8 0 4v73.9c0 6 4.8 10.8 10.8 10.8h67.7Z"
        style={{
          fill: '#eaeef9',
        }}
      />
      <path
        d="M10.8 88.8c5.2 0 9.5-3.9 10.2-8.9 0-.8.8-1.4 1.6-1.4h64.3c1 0 1.8.9 1.6 1.9-.9 4.8-5.1 8.4-10.1 8.4H10.8Z"
        className="st1"
      />
      <path
        d="M70.2 71.6H51.1c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1h19.1c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1M25.4 32.7H8.1c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1h17.3c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1M70.2 43.4H31.5c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1h38.7c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1M24.3 43.4H8.1c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1h16.2c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1M70.2 52.4H51.1c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1h19.1c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1M43.9 52.4H8.1c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1h35.8c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1M70.2 61.4H31.5c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1h38.7c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1M24.3 61.4H8.1c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1h16.2c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1"
        className="st0"
      />
      <path
        d="M70.2 71.6H51.1c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1h19.1c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1M22.9 12.8c0-2.1-.8-4.1-2.3-5.5C19.1 5.8 17.1 5 15 5s-4.1.8-5.6 2.3-2.3 3.5-2.3 5.6.8 4.1 2.3 5.6 3.4 2.3 5.5 2.3h.2c2.1 0 4.1-.8 5.6-2.3l.3-.3-1.2-1.2-.3.3c-1.2 1.2-2.7 1.8-4.4 1.8s-3.2-.6-4.4-1.8-1.8-2.7-1.8-4.4.7-3.2 1.8-4.4c1.2-1.2 2.7-1.8 4.4-1.8s3.2.6 4.4 1.8 1.6 2.2 1.8 3.5H20c-.2-1-.7-1.9-1.4-2.6-.9-.9-2.2-1.5-3.5-1.5s-2.6.5-3.5 1.5-1.5 2.2-1.5 3.5.5 2.6 1.5 3.5c.9.9 2.1 1.4 3.4 1.5 1.3 0 2.6-.5 3.5-1.5l.3-.3-1.2-1.2-.3.3c-.6.6-1.4.9-2.3.9s-1.7-.3-2.3-.9c-.4-.4-.7-.9-.8-1.4H23v-.9m-8.1-.9h-3.1c.2-.5.4-1 .8-1.4.6-.6 1.4-.9 2.3-.9s1.7.3 2.3.9c.4.4.7.9.8 1.4h-3.1ZM70.2 32.7H31.5c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1h38.7c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1"
        className="st0"
      />
      <g className="st2">
        <path
          d="M32.6 14.9h-1.7v4.2h-2.4V6.7h4.6c2.8 0 4.3 1.8 4.3 4.1s-.8 3.1-2.4 3.7l2.7 4.6H35l-2.5-4.2Zm-1.8-2.2H33c1.2 0 1.9-.8 1.9-1.8s-.7-1.8-1.9-1.8h-2.2v3.6Z"
          className="st1"
        />
      </g>
      <g className="st2">
        <path
          d="M49.6 12.5v3.9c-1 1.8-2.8 2.9-5.1 2.9-3.6 0-6-2.8-6-6.3s2.5-6.3 6-6.3 4.1 1.1 5.1 2.9l-2.1 1.1c-.6-1-1.6-1.6-3-1.6-2.3 0-3.6 1.7-3.6 4s1.3 3.9 3.6 3.9 2.1-.4 2.8-1.2v-1.4h-2.7v-1.9h5.1-.1ZM60.4 10.9c0 2.3-1.5 4.1-4.3 4.1h-2.2v4.2h-2.4V6.8h4.6c2.8 0 4.3 1.8 4.3 4.1Zm-2.5 0c0-1.1-.8-1.8-1.9-1.8h-2.2v3.6H56c1.2 0 1.9-.8 1.9-1.8ZM72.3 13c0 3.6-2.4 6.2-6.5 6.2h-4V6.8h4c4.1 0 6.5 2.6 6.5 6.2ZM70 13c0-2.4-1.6-3.9-4.2-3.9h-1.6V17h1.6c2.6 0 4.2-1.6 4.2-3.9Z"
          className="st1"
        />
      </g>
    </svg>
  );
}
